import { gqlTagGira } from '@atlassian/jira-apollo-gira';

export const DEV_SUMMARY_FRAGMENT = gqlTagGira`
    fragment DevSummaryFieldFragment on JiraIssueDevSummaryResult {
        devSummary {
            commit {
                overall {
                    count
                }
            }
            pullrequest {
                overall {
                    state
                    count
                }
            }
        }
    } 
`;
